export { default as TenantLogoLoader } from "./TenantLogoLoader";
